module.exports = __webpack_public_path__ + "img/img_3.5f749566.png";